export const isAdmin = (user) => user?.role === 'Admin';
export const isManagerOrAbove = (user) => ['Admin', 'Manager'].includes(user?.role);
export const hasPermission = (user, perm) => user?.permissions?.[perm] === true;
export const getRoleColor = (role) => ({
  Admin: '#84CC16',
  Manager: '#3b82f6',
  Warehouse: '#f59e0b',
  Sales: '#10b981',
  Finance: '#8b5cf6',
}[role] || '#6b7280');
